import styled from "styled-components";
import { typographyMixin } from "../../typography";
import { BreakPoints } from "../../constants";
import { gamesheetColours } from "../../colors";


export const StyledModal = styled.div.attrs({ className: "gs-modal-container" })`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  .gs-modal-sheet {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: #36383d;
    opacity: 0.5;
    z-index: 100;
    filter: blur(3px);

    &.hidden {
      display: none;
    }
  }

  .gs-modal {
    ${typographyMixin}

    overflow: hidden;
    max-height: 90%;

    position: relative;

    max-width: calc(600px + 2rem);

    margin: 0 1rem;

    font-size: 0.9rem;
    z-index: 101;
    background-color: #f5f5f4;
    border-radius: 0.3125rem;

    box-shadow: 0px 4px 4px 0px rgba(54, 56, 61, 0.4);

    overflow: hidden;

    display: flex;
    flex-direction: column;

    .gs-modal-content {
      height: 100%;
      width: 100%;
      padding: 1.075rem 1.075rem;
      overflow: auto;
      display: flex;
      flex-direction: column;
    }

    &.hidden {
      display: none;
    }
  }
`;

export const ModalTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0.3125rem 0.3125rem 0rem 0rem;
  background: ${gamesheetColours.secondary[500]};
  color: #fff;

  svg {
    margin-right: 1.25rem;
    flex-shrink: 0;
  }

  @media (min-width: ${BreakPoints.md}) {
    justify-content: center;

    .close-button {
      position: absolute;
      right: 1.25rem;
    }
    svg {
      margin-right: 0;
    }
  }


`;


export const ModalTitle = styled.div`
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  padding: 0.75rem 1.25rem;
`;

export const ModalFooter = styled.div`
  color: #000;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
